import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { alpha, Box, Button, IconButton, Typography } from '@material-ui/core'
import { Menu } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  list: {
    width: 250
  },
  fullList: {
    width: 'auto',
    borderBttomLeftRadius: 10,
    borderBottomRightRadius: 10
  },
  listItem: {
    // style active item
    '&.Mui-selected': {
      background: alpha(theme.palette.secondary.main, 0.1),
      color: theme.palette.secondary.main
    }
  }
}))

interface IFormWrapperDrawerProps {
  tabs: {
    label: string
    onClick?: (newValue: any) => void
  }[]
  handleTabChange: (event: unknown, value: number) => void
  menuLabel: string
  activeTab: number
}

const FormWrapperDrawer = ({
  tabs,
  handleTabChange,
  menuLabel,
  activeTab
}: IFormWrapperDrawerProps) => {
  const classes = useStyles()
  const [drawerOpen, setDrawerOpen] = React.useState(false)

  const toggleDrawer = (isOpen: boolean) => {
    setDrawerOpen(isOpen)
  }

  const list = () => (
    <div
      className={clsx(classes.fullList)}
      role='presentation'
      onClick={() => toggleDrawer(false)}
      onKeyDown={() => toggleDrawer(false)}
      data-testid='drawer'
    >
      <Box padding={1}>
        <Typography variant='h6'>{menuLabel}</Typography>
      </Box>
      <Divider />
      <List>
        {tabs.map((tab, index) => (
          <ListItem
            button
            key={tab.label}
            onClick={() => {
              handleTabChange(null, index)
              tab.onClick && tab.onClick(index)
            }}
            selected={activeTab === index}
            className={classes.listItem}
          >
            <ListItemText
              primary={tab.label}
              secondary={
                activeTab === index ? 'Currently Viewing' : 'Tap to navigate'
              }
            />
          </ListItem>
        ))}
        <ListItem className={classes.listItem}>
          <Button
            variant='contained'
            color='default'
            onClick={() => {
              toggleDrawer(false)
            }}
            style={{
              width: '100%'
            }}
          >
            Dismiss
          </Button>
        </ListItem>
      </List>
    </div>
  )

  return (
    <div>
      <React.Fragment key={'bottom'}>
        <IconButton
          color='inherit'
          aria-label='menu'
          onClick={() => toggleDrawer(true)}
        >
          <Menu />
        </IconButton>
        <Drawer
          anchor={'bottom'}
          open={drawerOpen}
          onClose={() => toggleDrawer(false)}
        >
          {list()}
        </Drawer>
      </React.Fragment>
    </div>
  )
}

export default FormWrapperDrawer
